import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core'
import { SelectionModel } from '@angular/cdk/collections'

import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatTableModule, MatTableDataSource } from '@angular/material/table'
import { MatCheckboxModule } from '@angular/material/checkbox'

import { JsonPipe, NgClass, NgIf } from '@angular/common'

import { CnpjPipe } from '../../pipes/cpnj.pipes'
import { CpfPipe } from '../../pipes/cpf.pipes'
import { TelefonePipe } from '../../pipes/phone.pipes'
import { MatProgressSpinner } from '@angular/material/progress-spinner'

interface modelLoading {
  replierItem: boolean
  contract: boolean
  email: boolean
  download: boolean
  edit: boolean
  manager: boolean
  view: boolean
  remove: boolean
  cancelContract: boolean
}

@Component({
  selector: 'table-list-os',
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatTableModule,
    MatCheckboxModule,
    NgIf,
    CnpjPipe,
    CpfPipe,
    TelefonePipe,
    JsonPipe,
    MatProgressSpinner,
    NgClass,
  ],
  templateUrl: './table-list-os.component.html',
  styleUrl: './table-list-os.component.scss',
})
export class TableListOSComponent implements OnInit, OnChanges {
  constructor() {}

  @Input() dataSource: any[] = []
  @Input() columns: any[] = []
  @Input() passengers = false
  @Input() selectable = false
  @Output() selectionChange = new EventEmitter<any[]>()
  @Input() spinLoad: modelLoading = {
    contract: false,
    email: false,
    download: false,
    edit: false,
    manager: false,
    view: false,
    remove: false,
    cancelContract: false,
    replierItem: false,
  }
  @Output() selectItem = new EventEmitter<any>()
  @Output() viewItem = new EventEmitter<any>()
  @Output() downloadItem = new EventEmitter<any>()
  @Output() deleteItem = new EventEmitter<any>()
  @Output() managerItem = new EventEmitter<any>()
  @Output() sendContract = new EventEmitter<any>()
  @Output() sendEmail = new EventEmitter<any>()
  @Output() cancelContract = new EventEmitter<any>()
  @Output() replierItem = new EventEmitter<any>()
  @Output() itineraryItem = new EventEmitter<any>()
  @Output() addPassengerItem = new EventEmitter<any>()
  @Output() deletarItem = new EventEmitter<any>()
  @Output() removerAssociacoes = new EventEmitter<any>()

  displayedColumns: string[] = []
  tableSource = new MatTableDataSource<any>()
  selection = new SelectionModel<any>(true, [])

  ngOnInit() {
    if (this.dataSource.length > 0) {
      this.buildDisplayedColumns()
      this.tableSource = new MatTableDataSource<any>(this.dataSource)
      this.updateTableDataSource()
    }
  }

  private buildDisplayedColumns() {
    const cols = this.columns.map((obj: any) => obj.keyColumn)
    this.displayedColumns = this.selectable ? ['select', ...cols] : cols
  }

  isAllSelected() {
    return this.selection.selected.length === this.tableSource.data.length
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear()
    } else {
      this.selection.select(...this.tableSource.data)
    }
    this.selectionChange.emit(this.selection.selected)
  }

  toggleRow(row: any) {
    this.selection.toggle(row)
    this.selectionChange.emit(this.selection.selected)
  }

  ngOnChanges() {
    this.buildDisplayedColumns()
    this.selection.clear()
    this.updateTableDataSource()
  }

  formatTime(time: string) {
    if (time) {
      const arrTime = time.split(':')
      if (arrTime.length > 1) {
        return `${arrTime[0]}:${arrTime[1]}`
      } else {
        return ''
      }
    } else {
      return ''
    }
  }

  private updateTableDataSource() {
    if (this.displayedColumns.length === 0 && this.columns.length > 0) {
      this.buildDisplayedColumns()
    }
    this.tableSource.data = this.dataSource
  }

  downloadItemEvent(item: any): void {
    this.downloadItem.emit(item)
  }

  viewItemEvent(item: any): void {
    this.viewItem.emit(item)
  }

  selectItemEvent(item: any): void {
    this.selectItem.emit(item)
  }

  deleteItemEvent(item: any): void {
    this.deleteItem.emit(item)
  }

  sendContractEvent(item: any): void {
    this.sendContract.emit(item)
  }

  sendEmailEvent(item: any): void {
    this.sendEmail.emit(item)
  }

  managerItemEvent(item: any): void {
    this.managerItem.emit(item)
  }

  replierItemEvent(item: any): void {
    this.replierItem.emit(item)
  }

  cancelContractEvent(item: any): void {
    this.cancelContract.emit(item)
  }

  itineraryItemEvent(item: any): void {
    this.itineraryItem.emit(item)
  }

  addPassengerItemEvent(item: any): void {
    this.addPassengerItem.emit(item)
  }

  deletarItemEvent(item: any): void {
    this.deletarItem.emit(item)
  }

  removerAssociacoesEvent(item: any): void {
    this.removerAssociacoes.emit(item)
  }

  validStatus(status: any) {
    const listValid: number[] = [2, 4, 5]
    if (typeof status == 'number') {
      if (listValid.includes(status)) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  checkColor(row: any) {
    if (this.passengers && row.repetido) {
      return 'line-red'
    }
    if (row.isEmergencial) {
      return 'line-red'
    }
    return ''
  }
}
